import { render, staticRenderFns } from "./ArticleCover.vue?vue&type=template&id=15b28487&scoped=true&"
import script from "./ArticleCover.vue?vue&type=script&lang=js&"
export * from "./ArticleCover.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCover.vue?vue&type=style&index=0&id=15b28487&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b28487",
  null
  
)

export default component.exports